import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'
import { FormRegistryService } from './form-registry.service'

export const unsavedChangesGuard: CanDeactivateFn<unknown> = () => {
  const formRegistry = inject(FormRegistryService)
  if (formRegistry.hasUnsavedChanges()) {
    return globalThis.confirm('Sie haben ungespeicherte Änderungen. Möchten Sie den Tab wirklich verlassen?')
  }
  return true
}
